import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Flower({ className = null }: IconProps) {
    return (
        <div className={classNames(className)}>
            <svg
                width="115px"
                height="115px"
                viewBox="0 0 115 115"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <path
                    d="M114.5,74.7c-2.2,7.2-12.3,10.2-16.8,15.7s-5.6,16.2-12.1,19.6c-6.4,3.4-15.7-1.5-23-.8s-15.1,7.5-22.4,5.3-10.2-12.3-15.7-16.8-16.2-5.6-19.6-12.1,1.5-15.7.8-23S-1.8,47.5.4,40.3s12.3-10.2,16.8-15.7,5.6-16.2,12.1-19.6,15.7,1.5,23,.8S67.4-1.8,74.7.4s10.2,12.3,15.7,16.8,16.2,5.6,19.6,12.1-1.5,15.7-.8,23c.7,7.1,7.5,15.1,5.3,22.4Z"
                    fill="#f9f2e3"
                />
                <path
                    d="M114.5,74.7c-2.2,7.2-12.3,10.2-16.8,15.7s-5.6,16.2-12.1,19.6c-6.4,3.4-15.7-1.5-23-.8s-15.1,7.5-22.4,5.3-10.2-12.3-15.7-16.8-16.2-5.6-19.6-12.1,1.5-15.7.8-23S-1.8,47.5.4,40.3s12.3-10.2,16.8-15.7,5.6-16.2,12.1-19.6,15.7,1.5,23,.8S67.4-1.8,74.7.4s10.2,12.3,15.7,16.8,16.2,5.6,19.6,12.1-1.5,15.7-.8,23c.7,7.1,7.5,15.1,5.3,22.4Z"
                    fill="#99492c"
                />
                <path
                    d="M40.8,112.8c-7-2.1-9.7-12.1-15.1-16.5-5.5-4.5-15.8-5.3-19.1-11.5s1.7-15.2,1-22.3S0,47.8,2.2,40.8s12.1-9.7,16.5-15.1c4.5-5.5,5.3-15.8,11.5-19.1s15.2,1.7,22.3,1S67.1,0,74.1,2.2s9.7,12.1,15.1,16.5c5.5,4.5,15.8,5.3,19.1,11.5s-1.7,15.2-1,22.3,7.5,14.7,5.4,21.7-12.1,9.7-16.5,15.1-5.3,15.8-11.5,19.1-15.2-1.7-22.3-1-14.7,7.5-21.7,5.4Z"
                    fill="none"
                    stroke="#f9f2e3"
                    strokeMiterlimit="10"
                    strokeWidth=".6"
                />
                <path
                    d="M41.3,111.1c-6.8-2-9.3-11.9-14.5-16.2s-15.5-5-18.7-11,1.9-14.8,1.2-21.7-7.5-14.2-5.5-21,11.9-9.3,16.2-14.5,5-15.5,11-18.7,14.8,1.9,21.7,1.2,14.2-7.5,21-5.5,9.3,11.9,14.5,16.2,15.5,5,18.7,11c3.2,6-1.9,14.8-1.2,21.7s7.5,14.2,5.5,21-11.9,9.3-16.2,14.5-5,15.5-11,18.7-14.8-1.9-21.7-1.2c-6.6.7-14.2,7.5-21,5.5Z"
                    fill="none"
                    stroke="#f9f2e3"
                    strokeMiterlimit="10"
                    strokeWidth=".6"
                />
                <g>
                    <path
                        d="M76.4,31.6c-.4.3-.9.5-1.4.7-.9.4-1.8.7-2.7.8-1.1.2-2.1.3-3.2.3-1.2,0-2.5-.2-3.7-.6s-2.4-.9-3.4-1.6c-.9-.6-1.7-1.2-2.5-2-.7-.7-1.3-1.4-1.8-2.2-.3-.4-.5-.9-.8-1.3,1.6-5.4,7.2-8.4,12.6-6.8s8.5,7.3,6.8,12.6Z"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M68.1,58.9c-2.6,7.6-6.8,7.4-6.8,7.4,0,0-5-3.5-1.4-15.5-3.6,12.1-9.7,12.2-9.7,12.2,0,0-3.5-2.1-1.5-9.9"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M76.4,59.3c.5-6.6-.2-16.4-4.1-26.2"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M69.1,33.4s-3.3,15.4-1,25.5c.9,4.1,2.8,7.3,6.1,8.3s1.9-2.9,2.2-8"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M62,31.3s-5.8,14.7-13.3,21.8c-3,2.9-6.4,4.6-9.7,3.6s0-3.5,2.6-7.9c3.2-5.7,9.2-13.5,17.9-19.5"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M76.4,59.3h0c.1.2,2.2,3.4,6.2,4.5s1.6-2.6.8-7.4c-.9-5.9-3.5-14.8-8.5-24.1"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M41.6,48.8s-3.6,1.6-7.7.4.1-3,3.4-6.7c4-4.5,11.1-10.4,20.4-15.4"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M83.5,56.4s3.5,3.6,7.3,3.3c1.8-.2-1.2-16.5-14.4-28.1"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M37.3,42.5s-4.9,1.1-7.9-1.3c-1.4-1.1,10.1-13.1,27.5-15.4"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <line
                        x1="60"
                        y1="50.9"
                        x2="65.4"
                        y2="32.8"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <line
                        x1="47"
                        y1="93.9"
                        x2="59.5"
                        y2="52.3"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M91.6,81.6c-11.8-3.5-24.3-1.9-34.5,4.1-3.7,2.2-7.1,4.9-10.1,8.2-.7-4.4-2-8.6-3.9-12.4-5.2-10.6-14.7-18.9-26.5-22.5"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M57.1,85.7c11.3,6.1,25.3,4.5,34.5-4.1"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                    <path
                        d="M43.1,81.5c-12.8-1.1-23.5-10.2-26.5-22.5"
                        fill="none"
                        stroke="#f9f2e3"
                        strokeMiterlimit="10"
                        strokeWidth=".6"
                    />
                </g>
                <path
                    d="M76.4,31.6c-.4.3-.9.5-1.4.7-.9.4-1.8.7-2.7.8-1.1.2-2.1.3-3.2.3-1.2,0-2.5-.2-3.7-.6s-2.4-.9-3.4-1.6c-.9-.6-1.7-1.2-2.5-2-.7-.7-1.3-1.4-1.8-2.2-.3-.4-.5-.9-.8-1.3,1.6-5.4,7.2-8.4,12.6-6.8s8.5,7.3,6.8,12.6Z"
                    fill="#f9f2e3"
                />
            </svg>
        </div>
    );
}

export default Flower;
